<template>
  <div class="w-full mt-4 flex flex-col items-center gap-4 !shadow-none">
    <slot />
  </div>
</template>
<script setup></script>
